import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { UploadProps } from '../../../types/reduxTypes/upload';

const createReducer = <T extends SliceCaseReducers<UploadProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setUploadData(state, action) {
    state.uploadData = action.payload;
  }
});

export default reducers;
